<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Administracion de Usuarios</h4>
            <p>Registro, Actualizacion y asignacion de Roles de Usuario</p>        
        </div>
    </div>
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#new-person" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Nueva Persona</a>
            <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-new-user" role="tab" aria-controls="nav-new" aria-selected="false" v-if="cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'OPERADOR RRHH'"><font-awesome-icon icon="user-plus" /> Creacion Usuario</a>
            <a class="nav-item nav-link" id="nav-delete-capitan" data-toggle="tab" href="#nav-update-person" role="tab" aria-controls="nav-del" aria-selected="false" ><font-awesome-icon icon="sync-alt" /> Actualizacion Datos Persona</a>
            <a class="nav-item nav-link" id="nav-delete-capitan" data-toggle="tab" href="#nav-admin-user" role="tab" aria-controls="nav-del" aria-selected="false" v-if="cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'OPERADOR RRHH'"><font-awesome-icon icon="sync-alt" />Administracion de Usuarios</a>
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="new-person" role="tabpanel" aria-labelledby="nav-capitan-tab">
            <br><br>
            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="name_person">Nombre <span class="required-text">*</span></label>
                    <input type="text" class="form-control" placeholder="Nombre" autocomplete="off" v-model="person.name">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="first_person">Primer Apellido <span class="required-text">*</span></label>
                    <input type="text" class="form-control" placeholder="Paterno" autocomplete="off" v-model="person.patern_name">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="last_person">Segundo Apellido</label>
                    <input type="text" class="form-control" placeholder="Materno" autocomplete="off" v-model="person.matern_name">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="grade">Grado <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person.grade">
                        <option v-for="gr in grades" :key="gr.id" :value="gr.id">{{ gr.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="grade">Especialidad <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person.especiality">
                        <option v-for="esp in especialitys" :key="esp.id" :value="esp.id">{{ esp.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="grade">Cargo <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person.charge">
                        <option v-for="ch in charges" :key="ch.id" :value="ch.id">{{ ch.detail }}</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="category_user">Categoria Personal <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person.category">
                        <option v-for="ct in categorys" :key="ct.id" :value="ct.id">{{ ct.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="date_register">Fecha Incorporacion Puesto <span class="required-text">*</span></label>
                    <datetime  v-model="person.incorporation" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Incorporacion" value-zone="America/La_Paz" ></datetime>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="date_init_ordop">Fecha Nacimiento <span class="required-text">*</span></label>
                    <datetime v-model="person.birthday" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz" ></datetime>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="last_person">Cedula Identidad <span class="required-text">*</span></label>
                    <input  type="text" class="form-control" autocomplete="off" placeholder="Ejm. 4756221" v-model="person.identification">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="grade">Expedido <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person.issued">
                        <option v-for="ci in citys" :key="ci.id" :value="ci.id">{{ ci.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="last_person">Numero de telefono</label>
                    <input  type="number" class="form-control" autocomplete="off" placeholder="Ejm. 71542554" v-model="person.phone">
                </div>
            </div>
            <br>
            <button class="btn btn-outline-info col-12 col-md-2 offset-md-5" @click="mRegisterPerson">
                <font-awesome-icon icon="save" size="2x" /> Registrar
            </button>

        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="nav-new-user" role="tabpanel" aria-labelledby="nav-new-tab" v-if="cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'OPERADOR RRHH' ">
            <br>
            <vue-bootstrap-typeahead                            
                v-model="persons"
                :data="persons_list"
                size="sm"
                :serializer="item => (item.grade +' '+item.complete)"
                @hit="mSelectPerson"
                :placeholder="searchPerson"                                        
            />
            <br><br>
            <div v-if="person_select.id > 0">
                <div class="form-row">
                    <div class="form-group col-12">
                        <label for="name_person">Persona Seleccionada</label>
                        <input type="text" class="form-control-plaintext" placeholder="Nombre" autocomplete="off" v-model="person_select.complete">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-12 col-md-4">
                        <label for="user">Usuario <span class="required-text">*</span></label>
                        <input type="text" class="form-control" placeholder="Usuario" autocomplete="off" v-model="userPerson.nick">
                    </div>

                    <div class="form-group col-12 col-md-4">
                        <label for="user">Role <span class="required-text">*</span></label>
                        <select class="form-control" v-model="userPerson.role">
                            <option v-for="ro in roles" :key="ro.id" :value="ro.id">{{ ro.detail }}</option>
                        </select>
                    </div>

                    <div class="form-group col-12 col-md-4">
                        <label for="user">Dependencia <span class="required-text">*</span></label>
                        <select class="form-control" v-model="userPerson.port">
                            <option v-for="port in ports_vigency" :key="port.id" :value="port.id"> {{ port.name_port }}</option>
                        </select>
                    </div>

                </div>
                <br>
                <button class="btn btn-outline-info col-12 col-md-2 offset-md-5" @click="mRegisterUser">
                    <font-awesome-icon icon="save" size="2x" /> Crear Usuario
                </button>
            </div>
            
        </div>

        <div class="tab-pane fade" id="nav-update-person" role="tabpanel" aria-labelledby="nav-del-tab" >
            <br>
            <h5>actualizacion de datos del personal</h5>
            <br>
            <div class="form-group col-12 col-md-6 offset-md-3">
                <label for="user_search">Busqueda de Persona</label>
                <vue-bootstrap-typeahead                            
                    v-model="personEdit"
                    :data="persons_list_complete"
                    size="sm"
                    :serializer="item => (item.grade +' '+item.complete)"
                    @hit="mSelectPersonEdit"
                    :placeholder="searchPerson"
                                        
                />
            </div>
                
            <br><br>
            <div v-if="person_edit.id_person > 0">
            
            <div v-if="cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'">
                <div class="form-row">
                    <div class="form-group col-12 col-md-4">
                        <label for="name_person">Nombre <span class="required-text">*</span></label>
                        <input type="text" class="form-control" placeholder="Nombre" autocomplete="off" v-model="person_edit.name">
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="first_person">Primer Apellido <span class="required-text">*</span></label>
                        <input type="text" class="form-control" placeholder="Paterno" autocomplete="off" v-model="person_edit.patern_name">
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="last_person">Segundo Apellido</label>
                        <input type="text" class="form-control" placeholder="Materno" autocomplete="off" v-model="person_edit.matern_name">
                    </div>
                </div>
            </div>
            <div v-else class="col-12">
                    <div class="alert alert-success col-12">
                        {{ person_edit.name }} {{ person_edit.patern_name }} {{ person_edit.matern_name }}
                    </div>
            </div> 
            

            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="grade">Grado <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person_edit.grade">
                        <option v-for="gr in grades" :key="gr.id" :value="gr.id">{{ gr.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-8">
                    <label for="grade">Especialidad <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person_edit.speciality">
                        <option v-for="esp in especialitys" :key="esp.id" :value="esp.id">{{ esp.detail }}</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="category_user">Categoria Personal <span class="required-text">*</span></label>
                    <select class="form-control" v-model="person_edit.category">
                        <option v-for="ct in categorys" :key="ct.id" :value="ct.id">{{ ct.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="date_register">Fecha Incorporacion Puesto <span class="required-text">*</span></label>
                    <datetime  v-model="person_edit.incorporation" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Incorporacion" value-zone="America/La_Paz" ></datetime>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="last_person">Cedula Identidad <span class="required-text">*</span></label>
                    <input v-if="cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'"  type="text" class="form-control" autocomplete="off" placeholder="Ejm. 4756221" v-model="person_edit.identification">
                    <span v-else><br>{{ person_edit.identification }}</span>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="date_init_ordop">Fecha Nacimiento <span class="required-text">*</span></label>
                    <datetime v-model="person_edit.birthday" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz" ></datetime>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="phone">Numero de Telefono <span class="required-text">*</span></label>
                    <input  type="text" class="form-control" autocomplete="off" placeholder="Ejm. 715444587" v-model="person_edit.phone">
                </div>
            </div>
            <br>
            <button class="btn btn-outline-warning col-12 col-md-2 offset-md-5" @click="mUpdatePerson">
                <font-awesome-icon icon="sync-alt" size="2x" /> Actualizar
            </button>
            </div>
        </div>

        <div class="tab-pane fade" id="nav-admin-user" role="tabpanel" aria-labelledby="nav-del-tab" v-if="cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'OPERADOR RRHH' ">
            <br>
            <h5>Administracion de usuarios de una persona</h5>
            <br>
            <div class="form-group col-12 col-md-6 offset-md-3">
                <label for="user_search">Busqueda de Persona</label>
                <vue-bootstrap-typeahead                            
                    v-model="personEdit"
                    :data="persons_list_complete"
                    size="sm"
                    :serializer="item => (item.grade +' '+item.complete)"
                    @hit="mSelectPersonUser"
                    :placeholder="searchPerson"
                                        
                />
            </div>
                
            <br><br>
            <div class="table-responsive" v-if="list_user.length > 0">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th align="center">#</th>
                            <th align="center">Nombre completo</th>
                            <th align="center">Usuario</th>
                            <th align="center">Categoria</th>
                            <th align="center">Unidad</th>
                            <th align="center">Estado</th>
                            <th align="center">Habilitar/Inhabilitar</th>
                            <th align="center">Reset Contraseña</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(us, key) in list_user" :key="us.id">
                            <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ key+1 }}</td>
                            <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ us.complete }}</td>
                            <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ us.nick }}</td>
                            <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ us.category }}</td>
                            <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ us.name_port }}</td>
                            <td v-if="us.category !=='SUPER ADMINISTRADOR'">
                                <span class="alert alert-success" v-if="us.state === 'A'"><font-awesome-icon icon="arrow-circle-up" size="lg" /></span>
                                <span class="alert alert-danger" v-else><font-awesome-icon icon="arrow-circle-down" size="lg" /></span></td>
                            <td v-if="us.category !=='SUPER ADMINISTRADOR' " align="center">
                                <button class="btn btn-success" v-if="us.state==='A'" @click="mChangeState(us.id, key)"><font-awesome-icon icon="toggle-on" size="lg" /></button>
                                <button class="btn btn-danger" v-else @click="mChangeState(us.id, key)"><font-awesome-icon icon="toggle-off" size="lg" /></button>
                            </td>
                            <td v-if="us.category !=='SUPER ADMINISTRADOR' " align="center"><button class="btn btn-warning" @click="mResetPass(us)"><font-awesome-icon icon="sync-alt" size="lg" /></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
const qs = require('qs');

export default {
    name:'admin-user',
    data(){
        return{
            persons_list_complete:[],
            userPerson:{
                nick:null,
                role:0,
                port:0
            },
            searchPerson:'Busqueda de Personas',
            persons:null,
            personEdit:null,
            personUser:null,
            persons_list:[],
            person_select:{
                id:0
            },
            ports_vigency:[],
            port_s:null,
            modal_load_id:'loading_port_boss',
            modal_load_title:'Cargando',
            status_send:true,
            port_select:{id:0},
            port_select_d:{id:0},
            person:{
                name:null,
                patern_name:null,
                matern_name:null,
                grade:null,
                speciality:null,
                identification:null,
                issued:null,
                birthday:null,
                incorporation:null,
                category:0,
                phone:0
            },
            person_edit:{
                id_person:0,
                name:null,
                patern_name:null,
                matern_name:null,
                grade:null,
                speciality:null,
                identification:null,
                issued:null,
                birthday:null,
                incorporation:null,
                category:0,
                phone:0
            },
            citys:[],
            grades:[],
            especialitys:[],
            charges:[],
            roles:[],
            categorys:[],
            list_user:[]
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
        this.chargeInit();
    },
    methods:{
        async mChangeState(idp, idx){
            let nstate;
            if(this.list_user[idx].state==='A'){
                this.list_user[idx].state='I';
                nstate=false;
            }else{
                this.list_user[idx].state='A';
                nstate=true;
            }
            let vuser={
                id:idp,
                ns:nstate
            }
            try {
                let ns=await axios.post(`updateStatusUser?api_token=${Vue.auth.getToken()}`, qs.stringify(vuser));    
                if(ns.data.status){
                    toastr.success(`${ns.data.response}`, 'Exito')
                }else{
                    toastr.error(`${ns.data.response}`, 'Error')
                }
            } catch (error) {
                console.log(error)
            }
        },
        mResetPass(usr){
            let message = {
                title: 'Reiniciar Contraseña',
                body: `¿Desea Continuar con el reinicio de contraseña del usuario <b>${usr.nick}</b>?`
            };
            // validar que los datos esten completos
            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            });
            npr.then(async (msg)=>{
                if(msg){
                    
                    try {
                                    
                        this.mShowModal(this.modal_load_id);
                        let reset_pass=await axios.get(`updatePasswordUser/${usr.id}?api_token=${Vue.auth.getToken()}`);

                        setTimeout(()=>{                                
                            if(reset_pass.data.status){
                                toastr.success(reset_pass.data.response, 'Exito');
                            }else{
                                toastr.error(reset_pass.data.response, 'Error');
                            }                                    
                            this.mHideModal(this.modal_load_id);
                        },1000)

                    }catch(err){                
                        setTimeout(()=>{
                            toastr.error('Ha ocurrido un error en el reinicio de la contraseña', 'Error')
                            this.mHideModal(this.modal_load_id);
                        }, 3000)
                    }
                }else{
                    console.log('No se reinicio la contraseña');
                }
            });
        },
        mValidateRegisterUser(){
            if( !(this.userPerson.nick !== null) ){
                toastr.warning('Indique el Nick del Usuario', 'Error');
                return false;
            }
            if( !(this.userPerson.role !== 0) ){
                toastr.warning('Indique el Rol de la Persona', 'Error');
                return false;
            }
            if( !(this.userPerson.port !==0) ){
                toastr.warning('Indique la dependencia a la cual la persona pertenece', 'Error');
                return false;
            }
            return true;
        },
        async mRegisterUser(){
            let vu=this.mValidateRegisterUser();
            if(vu){
                let dtsUser={
                    id:this.person_select.id,
                    nick:this.userPerson.nick,
                    role:this.userPerson.role,
                    port:this.userPerson.port
                }
                let message = {
                    title: 'Registro de Usuario',
                    body: `¿Desea Continuar con el Registro del usuario para la persona ${this.person_select.complete}?`
                };
                // validar que los datos esten completos
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // registramos y validamos el presupuesto general en la bd
                            try {
                                // let btn_send=document.getElementById(this.btn_r_ordop);
                                // this.btn_r_ordop = true;
                                
                                this.mShowModal(this.modal_load_id);
                                let s_reg_user=await axios.post(`savePersonUser?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsUser));

                                setTimeout(()=>{                                
                                    if(s_reg_user.data.status){
                                        toastr.success(s_reg_user.data.respuesta);
                                        this.person_select=[];
                                    }else{
                                        toastr.error(s_reg_user.data.respuesta, 'Error');
                                    }
                                    
                                    this.mHideModal(this.modal_load_id);
                                },1000)

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el registro RPE-01', 'Error')
                                    this.mHideModal(this.modal_load_id);
                                }, 3000)
                            }
                        }else{
                            console.log('No se guardo a la persona')
                            // console.log(this.dts_ordop);
                        }
                    });
            }
        },
        mValidateRegPerson(){
            if( !(this.person.name!==null) ){
                toastr.warning('Indique el Nombre de la Persona', 'Error');
                return false;
            }
            if( !(this.person.patern_name!==null) ){
                toastr.warning('Indique el Primer Apellido de la Persona', 'Error');
                return false;
            }
            if( !(this.person.grade!==null) ){
                toastr.warning('Seleccione el grado de la Persona', 'Error');
                return false;
            }
            if( !(this.person.especiality!==null) ){
                toastr.warning('Seleccione la especialidad de la Persona', 'Error');
                return false;
            }
            if(!(this.person.charge!==null)){
                toastr.warning('Seleccione el cargo de la Persona', 'Error');
                return false;
            }
            if(!(this.person.identification!==null)){
                toastr.warning('Indique el Numero de Identificacion de la Persona', 'Error');
                return false;
            }
            if(!(this.person.issued!==null)){
                toastr.warning('Seleccione donde fue expedido el carnet', 'Error');
                return false;
            }
            let adi=this.person.birthday.split('T');
            this.person.birthday=adi[0];

            if(this.person.birthday === null || !(this.person.birthday.length === 10)){
                toastr.warning('Indique la Fecha de Nacimiento', 'Error');
                return false;
            }

            if(this.person.category===0){
                toastr.warning('Seleccione la categoria de la persona', 'Error');
                return false;
            }

            let adin=this.person.incorporation.split('T');
            this.person.incorporation=adin[0];

            if(this.person.incorporation === null || !(this.person.incorporation.length === 10)){
                toastr.warning('Indique la Fecha de Incorporacion', 'Error');
                return false;
            }

            if( this.person.phone <= 0 ){
                this.person.phone=0;
            }

            return true;
        },
        
        mRegisterPerson(){
            let vd=this.mValidateRegPerson();
            if(vd){
                let message = {
                    title: 'Registro de Persona',
                    body: '¿Desea Continuar con el Registro de la Persona?'
                };
                // validar que los datos esten completos
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // registramos y validamos el presupuesto general en la bd
                            try {
                                // let btn_send=document.getElementById(this.btn_r_ordop);
                                // this.btn_r_ordop = true;
                                
                                this.mShowModal(this.modal_load_id);
                                let s_reg_per=await axios.post(`savePersonNew?api_token=${Vue.auth.getToken()}`, qs.stringify(this.person));

                                setTimeout(()=>{                                
                                    if(s_reg_per.data.status){
                                        toastr.success(s_reg_per.data.respuesta);
                                        this.person.name=null;
                                        this.person.patern_name=null;
                                        this.person.matern_name=null;
                                        this.person.grade=null;
                                        this.person.especiality=null;
                                        this.person.charge=null;
                                        this.person.identification=null;
                                        this.person.issued=null;
                                        this.person.birthday=null;
                                        this.person.incorporation=null;
                                        this.person.category=0;
                                        this.person.phone=0;
                                    }else{
                                        toastr.error(s_reg_per.data.respuesta, 'Error');
                                    }
                                    
                                    this.mHideModal(this.modal_load_id);
                                },1000)

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el registro RPE-01', 'Error')
                                    this.mHideModal(this.modal_load_id);
                                }, 3000)
                            }
                        }else{
                            console.log('No se guardo a la persona')
                            // console.log(this.dts_ordop);
                        }
                    });
            }
        },
        mValidateUpdatePerson(){
            if( !(this.person_edit.name!==null) ){
                toastr.warning('Indique el Nombre de la Persona', 'Error');
                return false;
            }
            if( !(this.person_edit.patern_name!==null) ){
                toastr.warning('Indique el Primer Apellido de la Persona', 'Error');
                return false;
            }
            if( !(this.person_edit.grade!==null) ){
                toastr.warning('Seleccione el grado de la Persona', 'Error');
                return false;
            }
            if( !(this.person_edit.speciality!==null) ){
                toastr.warning('Seleccione la especialidad de la Persona', 'Error');
                return false;
            }
            if(!(this.person_edit.identification!==null)){
                toastr.warning('Indique el Numero de Identificacion de la Persona', 'Error');
                return false;
            }
            console.log(this.person_edit.birthday);
            
            let adi=this.person_edit.birthday.split('T');
            this.person_edit.birthday=adi[0];

            if(this.person_edit.birthday === null || !(this.person_edit.birthday.length === 10)){
                toastr.warning('Indique la Fecha de Nacimiento', 'Error');
                return false;
            }

            if(this.person_edit.category===0){
                toastr.warning('Seleccione la categoria de la persona', 'Error');
                return false;
            }

            let adin=this.person_edit.incorporation.split('T');
            this.person_edit.incorporation=adin[0];

            if(this.person_edit.incorporation === null || !(this.person_edit.incorporation.length === 10)){
                toastr.warning('Indique la Fecha de Incorporacion', 'Error');
                return false;
            }
            return true;
        },        
        mUpdatePerson(){
            let vd=this.mValidateUpdatePerson();
            if(vd){
                let message = {
                    title: 'Actualizar datos de la Persona',
                    body: '¿Desea Continuar con la actualizacion de datos de la Persona?'
                };
                // validar que los datos esten completos
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // registramos y validamos el presupuesto general en la bd
                            try {
                                // let btn_send=document.getElementById(this.btn_r_ordop);
                                
                                this.mShowModal(this.modal_load_id);
                                let s_upd_per=await axios.post(`updatePerson?api_token=${Vue.auth.getToken()}`, qs.stringify(this.person_edit));
                                // console.log(s_upd_per);
                                setTimeout(()=>{                                
                                    if(s_upd_per.data.status){
                                        toastr.success(s_upd_per.data.response);
                                        this.person_edit.id_person=0;
                                        this.person_edit.name=null;
                                        this.person_edit.patern_name=null;
                                        this.person_edit.matern_name=null;
                                        this.person_edit.grade=null;
                                        this.person_edit.speciality=null;
                                        this.person_edit.charge=null;
                                        this.person_edit.identification=null;
                                        this.person_edit.issued=null;
                                        this.person_edit.birthday=null;
                                        this.person_edit.incorporation=null;
                                        this.person_edit.category=0;
                                    }else{
                                        toastr.error(s_upd_per.data.response, 'Error');
                                    }
                                    
                                    this.mHideModal(this.modal_load_id);
                                },1000)

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el registro RUPD-01', 'Error')
                                    this.mHideModal(this.modal_load_id);
                                }, 3000)
                            }
                        }else{
                            console.log('No se guardo a la persona')
                            // console.log(this.dts_ordop);
                        }
                    });
            }
        },
        async chargeInit(){
            // this.mShowModal(this.modal_load_id);
            
            // const ports = await axios.get(`getPorts`);        
            const ports = await axios.get(`getAllDependecies?api_token=${Vue.auth.getToken()}`);

            const citys = await axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`);
            const grade= await axios.get(`globals/grade?api_token=${Vue.auth.getToken()}`);
            const especiality= await axios.get(`globals/especiality?api_token=${Vue.auth.getToken()}`);
            const charge= await axios.get(`globals/charge?api_token=${Vue.auth.getToken()}`);
            const role= await axios.get(`globals/role?api_token=${Vue.auth.getToken()}`);
            let cate=await axios.get(`globals/category?api_token=${Vue.auth.getToken()}`);

            this.citys=citys.data;
            // this.ports_vigency=ports.data;

            ports.data.forEach((dtp)=>{
                let aux={
                    id:dtp.id,
                    name_port:dtp.name_port,
                    short_name_port:dtp.short_name_port,
                    ditrito:dtp.short_name_distrito,
                    category_port:dtp.category_port,
                    latitud:dtp.latitud,
                    longitud:dtp.longitud,
                    departament:dtp.departament,
                    aut_dispose_import:dtp.aut_dispose_import,
                    categoria_puerto:dtp.categoria_puerto,
                    categoria_resumen:dtp.categoria_resumen
                }
                this.ports_vigency.push(aux);
            });

            this.grades=grade.data;
            this.especialitys=especiality.data;
            this.charges=charge.data;
            this.roles=role.data;
            this.categorys=cate.data;

            setTimeout(()=>{
                // this.mHideModal(this.modal_load_id);
            },1000)
        },        
        mSelectPerson(data){            
            this.person_select.id=data.id;
            this.person_select.complete=data.complete;
            this.person_select.charge=data.complete;
        },
        mSelectPersonEdit(data){
            this.person_edit.id_person=data.id,
            this.person_edit.name=data.name,
            this.person_edit.patern_name=data.first_name,
            this.person_edit.matern_name=data.last_name,
            this.person_edit.grade=data.id_grade,
            this.person_edit.speciality=data.id_specialty,
            this.person_edit.identification=data.identification,
            // this.person_edit.issued=null,
            this.person_edit.birthday=data.birthday,
            this.person_edit.incorporation=data.incorporation,
            this.person_edit.category=data.category_person
            this.person_edit.phone=data.phone;
        },
        async mSelectPersonUser(data){
            this.mShowModal(this.modal_load_id);
            let s_upd_per=await axios.get(`getUsersPerson/${data.id}?api_token=${Vue.auth.getToken()}`);
            // console.log(s_upd_per);
            let nus=s_upd_per.data;
            setTimeout(()=>{                                

                if(nus.length>0){
                    // listar personal
                    this.list_user=nus;
                    console.log(this.list_user);
                }else{
                    // indicar que no hay usuarios registrados para esa persona
                    toastr.info(`No se ha encontrado usuarios registrados para la persona ${data.complete}`, 'Error');
                }                                    
                this.mHideModal(this.modal_load_id);
            },1000)
        },
        mShowModal(e){
            $(`#${e}`).modal('show');
        },
        mHideModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    watch:{
        persons(newPerson){
            axios.get(`searchPerson/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                console.log(res);
                this.persons_list=res.data;

            }).catch(err=>{
                console.log(err);
            })
        },
        personEdit(newPerson){
            axios.get(`searchPersonComplete/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                // console.log(res);
                this.persons_list_complete=res.data;

            }).catch(err=>{
                console.log(err);
            })
        },
        personUser(newPerson){
            axios.get(`searchPerson/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                console.log(res);
                this.persons_list=res.data;

            }).catch(err=>{
                console.log(err);
            })
        }
    },
    components:{
        'modal-loading':modalLoading
    },
    filters:{
        upperCase(value){
            return value.toUpperCase();
        }
    }
}
</script>

<style>
    .required-text{
        color:red; 
        font-weight:bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/user/AdminUser.vue